(() => {
  const radio = document.querySelector('[data-road-radio]');
  if (radio) {
    const audio = radio.querySelector('audio');
    const toggle = radio.querySelector('[data-radio-toggle]');
    const state = radio.querySelector('[data-radio-state]');
    const volumeControl = radio.querySelector('[data-radio-volume-control]');
    const volumeInput = radio.querySelector('[data-radio-volume-input]');
    const status = radio.querySelector('[data-radio-status]');
    const storageKey = 'rotgut-road-radio-v1';
    let saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); } catch (_) {}
    audio.volume = Math.min(1, Math.max(0, Number(saved.volume ?? audio.dataset.radioVolume) / 100));
    volumeInput.value = String(Math.round(audio.volume * 100));
    const remember = () => {
      try { sessionStorage.setItem(storageKey, JSON.stringify({src: audio.getAttribute('src'), time: audio.currentTime || 0, volume: Math.round(audio.volume * 100)})); } catch (_) {}
    };
    audio.addEventListener('loadedmetadata', () => {
      if (saved.src === audio.getAttribute('src') && Number.isFinite(saved.time) && saved.time < audio.duration) audio.currentTime = saved.time;
      saved = {};
    }, {once:true});
    const sync = () => {
      const playing = !audio.paused;
      toggle.setAttribute('aria-pressed', String(playing));
      toggle.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} Road radio`);
      state.textContent = playing ? 'Pause' : 'Play';
      volumeControl.hidden = !playing;
    };
    toggle.addEventListener('click', async () => {
      if (!audio.paused) { audio.pause(); return; }
      status.textContent = '';
      state.textContent = 'Loading';
      try { await audio.play(); } catch (_) { state.textContent = 'Retry'; status.textContent = 'Music could not start. Tap to retry.'; }
    });
    audio.addEventListener('play', sync);
    audio.addEventListener('pause', () => { sync(); remember(); });
    audio.addEventListener('error', () => { audio.pause(); state.textContent = 'Retry'; status.textContent = 'Music is temporarily unavailable.'; });
    volumeInput.addEventListener('input', () => { audio.volume = Number(volumeInput.value) / 100; remember(); });
    window.addEventListener('pagehide', remember);
    document.addEventListener('visibilitychange', () => { if (document.hidden) { remember(); audio.pause(); } });
    document.addEventListener('play', event => { if (event.target !== audio && event.target.matches?.('video,audio')) audio.pause(); }, true);
    sync(); radio.hidden = false; document.body.classList.add('has-road-radio');
  }
  const article = document.querySelector('[data-ride-article]');
  if (article) {
    const progress = document.querySelector('[data-reading-progress]');
    const content = article.querySelector('.ride-article__content');
    let scheduled = false;
    const update = () => {
      const rect = article.getBoundingClientRect();
      const length = Math.max(1, article.offsetHeight - innerHeight);
      if (progress) progress.style.transform = `scaleX(${Math.max(0, Math.min(1, -rect.top / length))})`;
      scheduled = false;
    };
    const requestUpdate = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', requestUpdate, {passive:true});
    window.addEventListener('resize', requestUpdate);
    content?.querySelectorAll('img').forEach(img => img.addEventListener('load', requestUpdate));
    update();
    const share = article.querySelector('[data-share-ride]');
    const status = article.querySelector('[data-share-status]');
    if (share && (navigator.share || navigator.clipboard?.writeText)) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        const url = document.querySelector('link[rel="canonical"]')?.href || location.href;
        try {
          if (navigator.share) await navigator.share({title:article.querySelector('h1').textContent,url});
          else { await navigator.clipboard.writeText(url); status.textContent = 'Link copied.'; }
        } catch (error) { if (error.name !== 'AbortError') status.textContent = 'Copy the page address to share this ride.'; }
      });
    }
  }
})();
